import {
  deleteCgwFile, getCgwList, getCgwPzYtjList, getCgwReviewInfo,
  getCgwYtjList, getRlIdByTaskId,
  saveCgwAndAudit, saveCgwAudit, updateCgwFile, updateCgwReviewer
} from "@/api/cgw";
import { sizeFormat } from '@/utils/utils';
const state = {
  rlId: null,
  cgwList: [],
  reviewList: [],
  cgwYtjList: [],
  cgwPzYtjList: [],

};
const mutations = {
  fetchCgwList(state, res) {
    if (res.code == 0) {
      res.data.forEach(item => {
        item.filesize = sizeFormat(item.filesize)
      })
      state.cgwList = res.data;
    }
  },
  fetchReviewList(state, res) {
    if (res.code == 0) {

      state.reviewList = res.data;
    }
  },
  fetchCgwYtjList(state, res) {
    if (res.code == 0) {
      res.data.forEach(item => {
        item.filesize = sizeFormat(item.filesize)
      })
      state.cgwYtjList = res.data;
    }
  },
  fetchCgwPzYtjList(state, res) {
    if (res.code == 0) {
      res.data.forEach(item => {
        item.filesize = sizeFormat(item.filesize)
      })
      state.cgwPzYtjList = res.data;
    }
  },
};
const actions = {
  fetchRlIdByTaskIdAction(context, { taskId }) {
    return new Promise((resolve, reject) => {
      getRlIdByTaskId(taskId)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchCgwListAction(context, { type, isTj }) {
    return new Promise((resolve, reject) => {
      getCgwList(type, isTj)
        .then((res) => {
          context.commit("fetchCgwList", res);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchCgwYtjListAction(context, { taskId, rlId }) {
    return new Promise((resolve, reject) => {
      getCgwYtjList(taskId, rlId)
        .then((res) => {
          context.commit("fetchCgwYtjList", res);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchCgwPzYtjListAction(context, { taskId, rlId }) {
    return new Promise((resolve, reject) => {
      getCgwPzYtjList(taskId, rlId)
        .then((res) => {
          context.commit("fetchCgwPzYtjList", res);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchCgwReviewAction(context, { taskId, rlId }) {
    return new Promise((resolve, reject) => {
      getCgwReviewInfo(taskId, rlId)
        .then((res) => {
          context.commit("fetchReviewList", res);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchUpdateBzAction(context, { fileId, bz }) {
    return new Promise((resolve, reject) => {
      updateCgwFile(fileId, bz)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchDeleteFileAction(context, { fileId, path }) {
    return new Promise((resolve, reject) => {
      deleteCgwFile(fileId, path)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  saveCgwAndAuditAction(context, { fileIds, taskId, bz, txlx, rwmc }) {
    return new Promise((resolve, reject) => {
      saveCgwAndAudit(fileIds, taskId, bz, txlx, rwmc)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  updateCgwReviewerAction(context, { taskId, rlId, reviewer, rwmc }) {
    return new Promise((resolve, reject) => {
      updateCgwReviewer(taskId, rlId, reviewer, rwmc)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  saveCgwAuditAction(context, { fileIds, id, rlId, taskId, status, isAdmin, ygbh, rwmc, txlx, bz }) {
    return new Promise((resolve, reject) => {
      saveCgwAudit(fileIds, id, rlId, taskId, status, isAdmin, ygbh, rwmc, txlx, bz)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
